import type {
  AggregationLevels,
  ComparisonAPIResponse,
  ConsumptionAPIResponse,
  ProductionAPIResponse,
  TemperatureAPIResponse,
} from '../types';

export const chronologicalStore = defineStore('chronologicalStore', () => {
  // ================================================== State
  const aggregationLevel = ref<AggregationLevels>('day');
  const consumptionType = ref<'consumption' | 'production'>('consumption');
  const showTemperature = ref<boolean>(false);

  // Consumption
  const loadingConsumption = ref<boolean>(true);
  const consumptionResponse = ref<ConsumptionAPIResponse | null>(null);
  const consumptionError = ref<ApiError | null>(null);

  // Production
  const loadingProduction = ref<boolean>(true);
  const productionResponse = ref<ProductionAPIResponse | null>(null);
  const productionError = ref<ApiError | null>(null);

  // Temperature
  const loadingTemperature = ref<boolean>(true);
  const temperatureResponse = ref<TemperatureAPIResponse | null>(null);
  const temperatureError = ref<ApiError | null>(null);

  // Comparison
  const areasToCompare = ref<{ id: number; start: string; color?: string }[]>([]);
  const loadingComparison = ref<boolean>(true);
  const comparisonResponse = ref<ComparisonAPIResponse | null>(null);
  const comparisonError = ref<ApiError | null>(null);

  // ================================================== Actions
  const setConsumptionType = (type: 'consumption' | 'production') => (consumptionType.value = type);

  // Consumption
  const setConsumptionResponse = (response: ConsumptionAPIResponse | null) => (consumptionResponse.value = response);
  const setLoadingConsumption = (loading: boolean) => (loadingConsumption.value = loading);
  const setConsumptionError = (error: ApiError | null) => (consumptionError.value = error);

  // Production
  const setProductionResponse = (response: ProductionAPIResponse | null) => (productionResponse.value = response);
  const setProductionError = (error: ApiError | null) => (productionError.value = error);
  const setLoadingProduction = (loading: boolean) => (loadingProduction.value = loading);

  // Temperature
  const setLoadingTemperature = (loading: boolean) => (loadingTemperature.value = loading);
  const setTemperatureResponse = (response: TemperatureAPIResponse | null) => (temperatureResponse.value = response);
  const setTemperatureError = (error: ApiError | null) => (temperatureError.value = error);
  const setShowTemperature = (show: boolean) => (showTemperature.value = show);

  // Comparison
  const setAreasToCompare = (areas: { id: number; start: string; color?: string }[]) => (areasToCompare.value = areas);
  const setComparisonResponse = (response: ComparisonAPIResponse | null) => (comparisonResponse.value = response);
  const setComparisonError = (error: ApiError | null) => (comparisonError.value = error);
  const setLoadingComparison = (loading: boolean) => {
    loadingComparison.value = loading;
  };

  return {
    loadingConsumption,
    consumptionResponse,
    consumptionError,
    loadingProduction,
    productionResponse,
    productionError,
    loadingTemperature,
    temperatureResponse,
    temperatureError,
    aggregationLevel,
    areasToCompare,
    loadingComparison,
    comparisonResponse,
    comparisonError,
    consumptionType,
    showTemperature,
    setConsumptionResponse,
    setConsumptionError,
    setProductionResponse,
    setProductionError,
    setLoadingConsumption,
    setLoadingProduction,
    setAreasToCompare,
    setLoadingComparison,
    setLoadingTemperature,
    setTemperatureResponse,
    setTemperatureError,
    setComparisonResponse,
    setComparisonError,
    setConsumptionType,
    setShowTemperature,
  };
});
